import useSWRMutation from 'swr/mutation'
import type { Manager } from '@ludus/core'
import { createManager, type NewManager } from '@/lib/api/managers.ts'
import { MANAGERS_KEY } from '@/shared/hooks/useManagers.ts'

export function useCreateManager() {
  const { trigger, isMutating } = useSWRMutation(
    MANAGERS_KEY,
    (_key: typeof MANAGERS_KEY, { arg }: { arg: NewManager }) => createManager(arg),
    {
      populateCache: (created: Manager, current: Manager[] | undefined) => [
        ...(current ?? []),
        created,
      ],
      revalidate: false,
    },
  )
  return { create: trigger, isMutating }
}
